import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CrudService } from '../../../crud/crud.service';
import { NotificationsService } from 'angular2-notifications';
import { CurrencyPipe } from "@angular/common";
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from "moment";
import { isObject } from 'util';
import { PagosModule } from 'app/servicio-financiero/pagos/pagos.module';

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';

@Component({
  selector: "app-venta-inscripcion",
  templateUrl: "./formulario.component.html"
})
export class VentaInscripcionComponent implements OnInit{
  dato: FormGroup;
  facturacion_inicio = false;
  form_pagos: any;
  form_movimientos_articulos: any;
  cargando = false;
  movimientos_articulos;
  codigo_barras_activo = false;
  caja_abierta = false;
  stocks = [];
  auto = 0;
  ticket;
  borrarCargando;
  error_venta = false;
  venta_ok = false;
  json;
  reimprimir = false;
  sin_resultado = "";

  pago_completado = false;
  movimiento;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");
  public preinscripciones_term: string = `${environment.API_URL}/preinscritos-auto?term=:keyword&empresa=${this.empresa}&sucursal=${this.sucursal}`;

  tieneid: boolean = false;
  time_cambio_cantidad_stoc;
  time_cambio_cantidad_articulo_key;
  time_pago;
  tamano = document.body.clientHeight;

  public startValue: string;
  public selected: string;
  public options = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  };

  url_nuevo = "../../nuevo";
  lista_colas = false;
  subtotal = 0;
  descuento = 0;
  iva = 0;
  total = 0;
  total_recibido = 0;
  cambio = 0;

  usuario;
  caja;
  busqueda;
  objeto = {
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 3000
  };
  preinscripciones = {
    preinscripciones_metadatos: {
      nombre: ""
    }
  };

  alumnos = {
    id: 0,
    alumnos_metadatos: {
      nombre: ""
    },
    becas: {
      importe: 0
    },
    personas_rfcs: [],
    factura_rfc: {
      razon_social: "",
      rfc: "",
      codigo_postal: ""
    }
  };
  documentos_no = false;

  constructor(
    private fb: FormBuilder,
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private http: HttpClient,
    private notificacion: NotificationsService
  ) {}
  observableSource = (keyword: any): Observable<any[]> => {
    
    let url: string =  `${environment.API_URL}/preinscritos-auto?term=${keyword}&empresa=${this.empresa}&sucursal=${this.sucursal}`;
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));
        
    } else {
      return Observable.bind([]);
    }
  }

  ngOnInit(): void {
    // obtener los datos del usiario logueado almacen y clues
    this.usuario = JSON.parse(localStorage.getItem("usuario"));
    this.caja = localStorage.getItem("caja");

    if (this.caja && this.caja != "") {
      this.caja_abierta = true;
    }
    // inicializar el formulario reactivo
    this.dato = this.fb.group({
      id: [""],
      tipos_movimientos_id: [2],
      personas_id: [""],
      pagos_publicos_id: [""],
      subtotal: [0],
      descuento: [0],
      iva: [0],
      requiere_factura: [0],
      pendiente_factura: [0],
      uso_cfdi: ["D10"],
      cajas_id: [this.caja],
      total: [0, [Validators.required]],
      total_recibido: [0, [Validators.required]],
      cambio: [""],
      devolucion_cambio: [1],
      codigo: [""],
      folio: [""],
      barcode: [""],
      recargo: [0],
      status_movimientos_id: [1],
      cuentas_bancarias_id: [""],
      status_introduccion: [""],
      status_pago: [""],
      fecha: [""],
      created_at: [""],
      comentarios: [""],
      cola: [""],
      valido: ["", [Validators.required]],
      devoluciones: this.fb.array([]),
      pago_completado: [""],
      pagos: this.fb.array([]),
      movimientos_articulos: this.fb.array([]),
      usuarios: this.fb.group({
        id: [""],
        nombre: [""]
      }),
      preinscripciones: this.fb.group({
        carreras_planes_id: [""],
        periodos_escolares_id: [""],
        grupos_id: [""],
        matricula: [""],
        nombre: [""],
        apellido_paterno: [""],
        apellido_materno: [""],
        fecha_nacimiento: [""],
        sexo: [""],
        estado_civil: [""],
        nacionalidades_id: [""],
        curp: [""],
        telefono_casa: [""],
        celular: [""],
        email: [""],
        nacimiento_estados_id: [""],
        nacimiento_municipios_id: [""],
        localidades_id: [""],
        estados_id: [""],
        municipios_id: [""],
        colonia: [""],
        calle: [""],
        no_exterior: [""],
        no_interior: [""],
        codigo_postal: [""],
        certificado_medico: [""],
        alergia: [""],
        discapacitado: [""],
        enfermedad_cronica: [""],
        descripcion_enfermedad_cronica: [""],
        descripcion_alergia: [""],
        seguro: [""],
        emergencia_nombre: [""],
        emergencia_celular: [""],
        escuela_nombre: [""],
        escuela_domicilio: [""],
        escuela_estados_id: [""],
        escuela_sector: [""],
        tutor_nombre: [""],
        tutor_domicilio: [""],
        tutor_telefono: [""],
        tutor_ocupacion: [""],
        acta_nacimiento: [""],
        certificado_preparatoria: [""],
        certificado_legalizado: [""],
        carta_conducta: [""],
        fotografias: [""],
        beca_promedio: [""],
        beca_convenio: [""]
      }),
      personas: this.fb.group({
        nombre: [""],
        apellido_materno: [""],
        apellido_paterno: [""]
      })
    });

    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    this.selected = "";
    this.startValue = "";
    // variable para crear el array del formulario reactivo
    this.form_pagos = {
      pagos_targetas: this.fb.group({
        banco: [""],
        folio: [""]
      }),
      tipos_metodos_pagos_id: ["PUE", [Validators.required]],
      tipos_formas_pagos_id: ["01", [Validators.required]],
      importe: [this.dato.controls["total"].value, [Validators.required]],
      paga_con: ["", [Validators.required]],
      cambio: ["", [Validators.required]],
      comentarios: [""]
    };

    this.agregar_forma_pago(<FormArray>(this.dato.controls.pagos), this.form_pagos);
    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
    if (document.getElementById("buscarArticulo")) setTimeout(() => {
        (<HTMLInputElement>document.getElementById("buscarArticulo")).focus;
      }, 100);

    ////////// facturacion
    this.iniciar_form_factura("D10");
  }

  /**
   * Este método formatea los resultados de la busqueda en el autocomplte
   * @param data resultados de la busqueda
   * @return void
   */
  autocompleListFormatter = (data: any) => {
    if (this.auto == 0) {
      $("ngui-auto-complete").attr(
        "style",
        $("ngui-auto-complete").attr("style") + "z-index:999"
      );
    }
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">
            ${data.nombre} ${
      data.apellido_paterno
    } ${data.apellido_materno}
            <small style="font-size: .5em; font-style: italic;">
           ${data.email}
            </small></h4>
            <h6>
              <strong>CURP: </strong> ${
                data.curp
              } <strong>Tutor: </strong> ${
      data.nombre
    }
              `;

    /*
    html += `<label class="tag is-success" >Domicilio: ${
      data.preinscripciones_metadatos.calle
    }, ${data.preinscripciones_metadatos.no_exterior}, ${
      data.preinscripciones_metadatos.colonia
    } </label>`;

    html += `<label class="tag is-warning" >CP : ${
      data.preinscripciones_metadatos.codigo_postal
    }</label>`;
    */

    html += `
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  cambiar_precio(p, i, modelo) {
    p = p.srcElement.value;
    modelo[i].controls["precio_unitario"].patchValue(
      modelo[i].get("articulos").value.articulos_precios[p].precio
    );
    this.calcular_importe_articulo();
  }
  /**
   * Este método agrega los lostes del modal a el modelo que se envia a la api
   * @return void
   */
  select_articulo_autocomplete(data) {

    if (isObject(data)) {
      this.venta_ok = false;
      this.cargando = true;
      this.auto = 0;
      // obtener el formulario reactivo para agregar los elementos
      const ctrl = <FormArray>this.dato.controls["movimientos_articulos"];
      if (ctrl.controls) {
        if (typeof ctrl.controls.length == "number") {
          while (ctrl.length) {
            ctrl.removeAt(ctrl.length - 1);
          }
          ctrl.reset();
        }
      }
      this.quitarPagosPublicos();

      this.preinscripciones = data;
      let articulos = this.preinscripciones["planes_pagos"];
      let becas = this.preinscripciones["becas"];

      if (typeof becas == "undefined" || becas == null) {
        becas.importe = 0;
      }

      if (becas.becas.es_porcentaje) {
        becas.importe = articulos.importe * (becas.importe / 100);
      }

      let recargo = 0;

      if (data.recargo_es_porcentaje) {
        recargo = articulos.importe * (parseFloat(data.recargo_importe) / 100);
      } else {
        recargo = parseFloat(data.recargo_importe);
      }

      if(this.tieneid)
        becas.importe = 0;
      let movimientos_articulos = {
        articulos_id: [articulos.articulos_id, [Validators.required]],
        cantidad: [1, [Validators.required]],
        cantidad_restante: [1],
        precio_unitario: [articulos.importe, [Validators.required]],
        articulos_precios_id: [1, [Validators.required]],
        importe: [articulos.importe, [Validators.required]],
        descuento: [becas.importe],
        precio_con_descuentos: [articulos.importe - becas.importe],
        iva_porcentaje: [0],
        iva_cantidad: [0],
        recargo: recargo,
        subtotal: [articulos.importe, [Validators.required]]
      };
      ctrl.insert(0, this.fb.group(movimientos_articulos));
      this.options = {
        position: ["top", "right"],
        timeOut: 5000,
        lastOnBottom: true
      };

      this.cargando = false;

      if (recargo > 0) {
        this.agregar_recargo(data, articulos);
      }

      if (data.documentos_validados == 0) {
        this.documentos_no = true;
        setTimeout(() => {
          this.documentos_no = false;
        }, 4000);
      } else {
        this.calcular_importe_articulo();
      }

      this.alumnos = data;
      this.alumnos.factura_rfc = data.personas_rfcs[0];
      if (document.getElementById("buscarArticulo"))
      (<HTMLInputElement>document.getElementById("buscarArticulo")).value = "";
    }
  }

  agregar_recargo(recar, articulos) {
    const ctrl = <FormArray>this.dato.controls["movimientos_articulos"];

    this.preinscripciones = recar;

    let recargo = 0;
    if (recar.recargo_es_porcentaje) {
      recargo = articulos.importe * (parseFloat(recar.recargo_importe) / 100);
    } else {
      recargo = parseFloat(recar.recargo_importe);
    }

    let articulor = recar;
    (articulor.nombre = "Recargo"), (articulor.codigo_barras = 5);

    let movimientos_articulos_recargo = {
      articulos_id: ["21765cdac7cde1ab1a7ba6857e06d2a3", [Validators.required]],
      cantidad: [1, [Validators.required]],
      nombre: ["Recargo", [Validators.required]],
      cantidad_restante: [1],
      precio_unitario: [recargo, [Validators.required]],
      articulos_precios_id: [""],
      importe: [recargo, [Validators.required]],
      descuento: [0, [Validators.required]],
      precio_con_descuentos: [recargo, [Validators.required]],
      iva_porcentaje: [0, [Validators.required]],
      iva_cantidad: [0, [Validators.required]],
      subtotal: [recargo, [Validators.required]],
      periodos_escolares_colegiaturas_id:
      articulor.periodos_escolares_colegiaturas_id,
      articulos: articulor
    };
    ctrl.push(this.fb.group(movimientos_articulos_recargo));
    this.dato.controls.recargo.patchValue(recargo);
  }

  calcular_importe_articulo() {
    // sumamos las cantidades
    let total = 0;
    let c = 0;
    let restante = 0;
    let descuento = 0;

    this.dato.get("movimientos_articulos").value.forEach(element => {
      let importe_desc = element.cantidad * element.precio_unitario;
      element.importe = element.cantidad * element.precio_unitario;

      if (element.descuento > 0) {
        let desc = parseFloat(element.descuento);
        element.precio_con_descuentos = importe_desc - desc;
        descuento += desc;
      } else {
        element.precio_con_descuentos = element.importe;
      }

      total = total + element.cantidad * element.precio_unitario;
      const ma = <FormArray>this.dato.controls.movimientos_articulos;
      const it = <FormGroup>ma.controls[c];
      it.controls.importe.patchValue(element.importe);
      it.controls.precio_con_descuentos.patchValue(
        element.precio_con_descuentos
      );
      c++;
    });

    let importe = 0;
    let cambio = 0;
    let i = 0;
    let efectivo = false;
    const pagos = <FormArray>this.dato.controls["pagos"];
    this.dato.get("pagos").value.forEach(element => {
      importe = importe + element.paga_con;
      if (element.tipos_formas_pagos_id == "01") efectivo = true;
    });

    this.dato.controls["subtotal"].patchValue(total);
    this.dato.controls["descuento"].patchValue(descuento);
    this.dato.controls["total"].patchValue(total - descuento);
    this.dato.controls["total_recibido"].patchValue(importe);
    if (efectivo) {
      this.dato.controls["cambio"].patchValue(importe - (total - descuento));
    } else {
      this.dato.controls["cambio"].patchValue(0);
    }

    if (importe >= total - descuento) {
      this.dato.controls["valido"].patchValue("si");

      if (restante > 0) {
        this.dato.controls["valido"].patchValue("");
        this.notificacion.alert(
          "Cantidad surtida",
          "Verifique que las cantidades coincidan con lo solicitado: ",
          this.objeto
        );
      }
    } else if (importe > 0) {
      this.dato.controls["valido"].patchValue("si");
    } else {
      this.dato.controls["valido"].patchValue("");
    }

    const imp = <FormGroup>pagos.controls[pagos.controls.length - 1];
    if (imp) {
      const pago = <FormArray>this.dato.controls.pagos;
      let p = pago.length - 1;
      if (p > 0) {
        pago.controls[p]["controls"]["importe"].patchValue(
          Math.abs(pago.controls[p - 1]["controls"]["cambio"].value)
        );
      } else {
        if (imp.controls.paga_con.value == "") {
          imp.controls.importe.patchValue(total - descuento);
        }
      }
    }
    let cambios = 0;
    if (efectivo) cambios = 0;
    else cambios = importe - (total - descuento);
    this.dato.get("pagos").value.forEach(element => {
      const imp = <FormGroup>pagos.controls[i];
      if (element.paga_con > 0 && efectivo) {
        cambios = this.dato.controls.cambio.value;
      }
      imp.controls["cambio"].patchValue(cambios);
      i++;
      cambios = Math.abs(cambios);
    });
  }

  validar_cantidad_pago(event, modelo, cantidad, tipo, i) {
    if (
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_pago);
      this.time_pago = setTimeout(() => {
        this.validar_pago(event, modelo, cantidad, tipo, i);
      }, 800);
    }
  }
  validar_pago(event, modelo, cantidad, tipo, i) {
    let success = true;
    if (tipo == "min") {
      if (modelo.value < cantidad) {
        success = false;
      }
    }
    if (tipo == "max") {
      if (modelo.value > cantidad) {
        success = false;
      }
    }
    /*if (!success) {
      modelo.patchValue(cantidad);
    }*/

    this.calcular_importe_articulo();
  }
  reset_form() {
    this.selected = "";
    this.startValue = "";
    this.dato.reset();
    for (let item in this.dato.controls) {
      const ctrl = <FormArray>this.dato.controls[item];
      if (ctrl.controls) {
        if (typeof ctrl.controls.length == "number") {
          while (ctrl.length) {
            ctrl.removeAt(ctrl.length - 1);
          }
          ctrl.reset();
        }
      }
    }
    this.dato.controls.tipos_movimientos_id.patchValue(2);
    this.dato.controls.status_movimientos_id.patchValue(1);
    this.agregar_forma_pago(
      <FormArray>this.dato.controls.pagos,
      this.form_pagos
    );
  }

  agregar_forma_pago(modelo: FormArray, formulario) {
    (<FormArray>modelo).push(this.fb.group(formulario));

    const pago = <FormArray>this.dato.controls.pagos;

    let p = pago.length - 1;
    if (p > 0) {
      pago.controls[p]["controls"]["importe"].patchValue(
        Math.abs(pago.controls[p - 1]["controls"]["cambio"].value)
      );
    }
  }

  enviar() {
    this.cargando = true;
    this.json = this.dato.getRawValue();
    this.json.preinscripciones = this.preinscripciones;
    document
      .getElementById("confirmarLiquidacion")
      .classList.remove("is-active");
    if (this.tieneid) {
      this.crudService
        .editar(this.dato.get("id").value, this.json, "inscripcion")
        .subscribe(
          resultado => {
            this.enviar_ticket(this.json, resultado);
          },
          error => {
            this.cargando = false;
            this.error_venta = true;
          }
        );
    } else {
      this.crudService.crear(this.json, "inscripcion").subscribe(
        resultado => {
          this.enviar_ticket(this.json, resultado);
          if (resultado.status == 200) {
            this.reset_form();
          }
        },
        error => {
          this.cargando = false;
          this.error_venta = true;
          setTimeout(() => {
            this.error_venta = false;
          }, 2500);
        }
      );
    }
  }

  enviar_ticket(json, resultado) {
    this.cargando = false;
    this.venta_ok = true;
    this.pago_completado = resultado.data.pago_completado;
    this.movimiento = resultado.facturacion;
    json = resultado.data.preinscripciones.movimientos;
    this.json.subtotal = parseFloat(this.json.subtotal);
    this.json.total = parseFloat(this.json.total);
    this.json.descuento = parseFloat(this.json.descuento);
    setTimeout(() => {
      this.venta_ok = false;
    }, 3000);

    // cargar los datos nuevamente despues de guardar y limpiar los pagos publicos
    if (document.getElementById("cargar_datos_actualizar"))
      document.getElementById("cargar_datos_actualizar").click();
    (<HTMLInputElement>document.getElementById("search-box")).value = "";
    this.pagos_publicos = [];

    this.error_venta = false;

    ////// facturacion si require factura y no se deja en pendiente
    this.iniciar_form_factura(this.dato.get("uso_cfdi").value);
    if (resultado.facturacion.requiere_factura) {
      this.ventas_facturar = [];
      this.cargar_factura(false, resultado);
    }else{
      this.json = resultado.data.preinscripciones.movimientos;
      this.calcular_importe_articulo();
      this.error_venta = false;
      this.reimprimir = true;
      if (JSON.parse(localStorage.getItem('configuracion')).sucursal.recibo) {
        setTimeout(() => {
          document.getElementById('imprimirTicket').click();
        }, 200);
      }
    }

    setTimeout(() => {
      this.venta_ok = false;
    }, 1500);
  }
  asignar_factura(movimiento){
    this.pago_completado = this.dato.get('pago_completado').value;
    this.movimiento = movimiento;
  }

  cambiar_rfc(val) {
    this.alumnos.factura_rfc = val;
  }

  /////////////////////////////////// facturacion ///////////////////////////////////
  facturacion;

  error_timbre = false;
  valido = false;
  error_busqueda = false;
  errores = [];
  todas_ventas = false;
  activarRfc = false;
  activarUso = false;
  seleccionar_iva = false;

  codigo = "";
  cliente = "";
  facturas_mes = [];
  requiere_factura = 1;

  ventas_facturar = [];
  ventas_mes_facturar = [];
  desglosar_impuestos = true;
  con_impuesto = true;
  VERSION_CFDI = environment.VERSION_CFDI;
  CFDI_PATH = environment.CFDI_PATH;

  date = new Date();

  abrir_facturacion() {
    this.facturacion.Receptor.Rfc = this.alumnos.factura_rfc.rfc;
    this.facturacion.Receptor.Nombre = this.alumnos.factura_rfc.razon_social;
    document.getElementById("verPdf").classList.add("is-active");
  }

  iniciar_form_factura(uso_cfdi) {
    this.facturacion = {
      Version: this.VERSION_CFDI,
      Serie: this.configuracion.sucursal.facturacion.serie,
      Folio: "",
      Fecha: moment
        .utc(
          moment(
            new Date(
              this.date.getTime() - this.date.getTimezoneOffset() * 60000
            )
          )
        )
        .format(),
      Sello: "",
      NoCertificado: "",
      Certificado: "",
      SubTotal: 0,
      Moneda: this.configuracion.sucursal.moneda,
      Total: 0,
      TotalLetra: "",
      TipoDeComprobante: "I",
      FormaPago: "",
      MetodoPago: "",
      CondicionesDePago: "Contado",
      Descuento: 0,
      LugarExpedicion: this.configuracion.sucursal.facturacion.lugar_expedicion,
      CfdiRelacionados: { TipoRelacion: "", CfdiRelacionado: [{ UUID: "" }] },
      Emisor: {
        Rfc: this.configuracion.sucursal.facturacion.rfc,
        Nombre: this.configuracion.sucursal.facturacion.razon_social,
        RegimenFiscal: this.configuracion.sucursal.facturacion.regimen_fiscal
      },
      Receptor: { Rfc: "", Nombre: "", UsoCFDI: uso_cfdi },
      Conceptos: { Concepto: [] },
      Impuestos: {
        TotalImpuestosTrasladados: 0,
        TotalImpuestosRetenidos: 0,
        Traslados: [],
        Retenciones: []
      },
      Complemento: {
        TimbreFiscalDigital: {
          FechaTimbrado: "",
          UUID: "",
          NoCertificadoSAT: "",
          SelloCFD: "",
          SelloSAT: "",
          CadenaOriginal: "",
          qr: ""
        }
      }
    };

    this.facturacion_inicio = true;
  }

  cargar_factura(es_publico, resultado) {
    if (resultado.status === 200) {
      this.facturacion.Receptor.Rfc = this.alumnos.factura_rfc.rfc;
      this.facturacion.Receptor.Nombre = this.alumnos.factura_rfc.razon_social;
      this.facturacion.Receptor.UsoCFDI = resultado.facturacion.uso_cfdi;
      this.valido = true;

      this.ventas_facturar.push(resultado.facturacion.id);

      let forma_pago = resultado.facturacion.pagos[0].tipos_formas_pagos_id;

      // datos generales
      this.facturacion.Serie = this.configuracion.sucursal.facturacion.serie;
      this.facturacion.Folio = resultado.facturacion.folio;

      this.facturacion.Fecha = moment
        .utc(
          moment(
            moment
              .utc(
                moment(
                  new Date(
                    this.date.getTime() - this.date.getTimezoneOffset() * 60000
                  )
                )
              )
              .format()
          )
        )
        .format();
      this.facturacion.FormaPago = forma_pago;
      this.facturacion.MetodoPago =
        resultado.facturacion.pagos[0].tipos_metodos_pagos_id;

      let suma_impuesto_rete = [];
      let suma_impuesto_tras = [];
      let suma_descuento = 0;
      let subtotal = 0;
      let total_descuento = 0;
      let total = 0;

      let grupos_impuestos = { Traslado: [], Retencion: [] };
      let todos_impuestos_t = [];
      let todos_impuestos_r = [];
      // conceptos
      resultado.facturacion.movimientos_articulos.forEach(elem => {
        let impuestos = elem.articulos.articulos_impuestos ? elem.articulos.articulos_impuestos.impuestos : { traslados: [], retenciones: [] };
        // importe del articulo
        let precio_unitario = 0;
        let importe = parseFloat(elem.importe);
        let impuesto_incluido = { Traslados: [], Retenciones: [] };
        // ver si se desglosa el impuesto, en caso contrario se agrega
        let descuento = 0;
        if (this.desglosar_impuestos) {
          let desglosar = 0;
          let imp_des = 0;
          impuestos.traslados.forEach(el => {
            let impp = importe - importe / (1 + parseFloat(el.cuota));
            desglosar += parseFloat(impp.toFixed(2));
            imp_des += parseFloat(el.cuota);
          });

          impuestos.retenciones.forEach(el => {
            let impp = importe - importe / (1 + parseFloat(el.cuota));
            desglosar += parseFloat(impp.toFixed(2));
            imp_des += parseFloat(el.cuota);
          });

          descuento = parseFloat(elem.descuento) / (1 + imp_des);

          importe = parseFloat((importe - desglosar).toFixed(2));

          precio_unitario = parseFloat((importe / elem.cantidad).toFixed(2));
          suma_descuento += parseFloat(descuento.toFixed(2));
        } else {
          let sumar = 0;
          descuento = parseFloat(elem.descuento);
          importe = parseFloat((importe + sumar).toFixed(2));
          precio_unitario = parseFloat((importe / elem.cantidad).toFixed(2));

          suma_descuento += descuento;
          impuestos.traslados.forEach(el => {
            let summ = importe - importe / (1 + parseFloat(el.cuota));
            sumar += parseFloat(summ.toFixed(2));
          });

          impuestos.retenciones.forEach(el => {
            let summ = importe - importe / (1 + parseFloat(el.cuota));
            sumar += parseFloat(summ.toFixed(2));
          });
        }
        impuestos.traslados.forEach(el => {
          if (!suma_impuesto_tras[el.clave]) {
            suma_impuesto_tras[el.clave] = 0;
          }
          let importe_impuesto = parseFloat((importe - descuento).toFixed(2));
          let impp = parseFloat(
            (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
          );
          suma_impuesto_tras[el.clave] += parseFloat(impp.toFixed(2));
          impuesto_incluido.Traslados.push({
            Traslado: {
              Base: importe_impuesto,
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: impp.toFixed(2)
            }
          });

          if (todos_impuestos_t.indexOf(el.clave) < 0) {
            todos_impuestos_t.push(el.clave);
            grupos_impuestos.Traslado.push(el);
          }
        });

        impuestos.retenciones.forEach(el => {
          if (!suma_impuesto_rete[el.clave]) {
            suma_impuesto_rete[el.clave] = 0;
          }
          let importe_impuesto = parseFloat((importe - descuento).toFixed(2));
          let impp = parseFloat(
            (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
          );
          suma_impuesto_rete[el.clave] += parseFloat(impp.toFixed(2));
          impuesto_incluido.Retenciones.push({
            Retencion: {
              Base: importe_impuesto,
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: impp.toFixed(2)
            }
          });
          if (todos_impuestos_r.indexOf(el.clave) < 0) {
            todos_impuestos_r.push(el.clave);
            grupos_impuestos.Retencion.push(el);
          }
        });
        total_descuento += descuento;
        subtotal += importe;
        // conceptos con complemento educativo
        if (elem.precio_unitario > 0)
        this.facturacion.Conceptos.Concepto.push({
          ClaveProdServ: elem.articulos.clave_prod_serv,
          ClaveUnidad: elem.articulos.unidades_medidas.clave,
          NoIdentificacion: elem.articulos.sku,
          Cantidad: elem.cantidad,
          Unidad: elem.articulos.unidades_medidas.nombre,
          Descripcion: elem.articulos.nombre.trim() + '(' + elem.articulos.created_at.substr(0, 7) + ')',
          ValorUnitario: precio_unitario.toFixed(2),
          PrecioReal: parseFloat(elem.precio_unitario),
          Descuento: descuento.toFixed(2),
          DescuentoReal: elem.descuento,
          Importe: importe.toFixed(2),
          Impuestos: impuesto_incluido,
          ComplementoConcepto: {
            version: "1.0",
            nombreAlumno:
              resultado.facturacion.personas.nombre +
              " " +
              resultado.facturacion.personas.apellido_paterno +
              " " +
              resultado.facturacion.personas.apellido_materno,
            CURP: resultado.facturacion.personas.curp,
            nivelEducativo:
              resultado.facturacion.personas.carrera.nivel_educativo,
            autRVOE: resultado.facturacion.personas.carrera.rvoe
          },
          iva: true
        });
      });
      let total_impuesto_tras = 0;
      let total_impuesto_rete = 0;

      grupos_impuestos.Traslado.forEach(el => {
        total_impuesto_tras += parseFloat(
          suma_impuesto_tras[el.clave].toFixed(2)
        );
        this.facturacion.Impuestos.Traslados.push({
          Traslado: {
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: suma_impuesto_tras[el.clave].toFixed(2)
          }
        });
      });
      grupos_impuestos.Retencion.forEach(el => {
        total_impuesto_rete += parseFloat(
          suma_impuesto_rete[el.clave].toFixed(2)
        );
        this.facturacion.Impuestos.Retenciones.push({
          Retencion: {
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: suma_impuesto_rete[el.clave].toFixed(2)
          }
        });
      });

      this.facturacion.Impuestos.TotalImpuestosTrasladados = total_impuesto_tras.toFixed(2);
      this.facturacion.Impuestos.TotalImpuestosRetenidos = total_impuesto_rete.toFixed(2);

      let T_Total =
        subtotal -
        total_descuento +
        (total_impuesto_tras + total_impuesto_rete);

      this.facturacion.SubTotal = subtotal.toFixed(2);
      this.facturacion.Descuento = total_descuento.toFixed(2);
      this.facturacion.Total = T_Total.toFixed(2);

      this.recalcular_impuesto();
      document.getElementById("verPdf").classList.add("is-active");
    }
  }

  recalcular_impuesto() {
    this.facturacion.Impuestos = {
      Traslados: [],
      Retenciones: []
    };

    let posicion = 0;
    let total_total_impuesto_tras = 0;
    let total_total_impuesto_rete = 0;
    let total_subtotal = 0;
    let suma_impuesto_rete = [];
    let suma_impuesto_tras = [];
    let suma_descuento = 0;
    let subtotal = 0;
    let total_descuento = 0;
    let total = 0;
    // conceptos
    if (this.facturacion.Conceptos.Concepto) {
      let grupos_impuestos = { Traslado: [], Retencion: [] };
      let todos_impuestos_t = [];
      let todos_impuestos_r = [];
      this.facturacion.Conceptos.Concepto.forEach(elem => {
        let impuestos = elem.Impuestos;
        // importe del articulo
        let importe = elem.PrecioReal * elem.Cantidad;
        elem.ValorUnitario = elem.PrecioReal;
        let impuesto_incluido = {
          Traslados: [],
          Retenciones: []
        };
        // ver si se desglosa el impuesto, en caso contrario se agrega

        let precio_unitario = 0;
        let descuento = 0;
        if (elem.iva) {
          if (this.desglosar_impuestos) {
            let desglosar = 0;
            let imp_des = 0;
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              let impp = importe - importe / (1 + el.TasaOCuota);
              desglosar += parseFloat(impp.toFixed(2));

              imp_des += el.TasaOCuota;

              if (todos_impuestos_t.indexOf(el.Impuesto) < 0) {
                todos_impuestos_t.push(el.Impuesto);
                grupos_impuestos.Traslado.push(el);
              }
            });

            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              let impp = importe - importe / (1 + el.TasaOCuota);
              desglosar += parseFloat(impp.toFixed(2));

              imp_des += el.TasaOCuota;

              if (todos_impuestos_r.indexOf(el.Impuesto) < 0) {
                todos_impuestos_r.push(el.Impuesto);
                grupos_impuestos.Retencion.push(el);
              }
            });
            descuento = parseFloat(elem.DescuentoReal) / (1 + imp_des);

            importe = parseFloat((importe - desglosar).toFixed(2));

            precio_unitario = parseFloat((importe / elem.Cantidad).toFixed(2));
            suma_descuento += parseFloat(descuento.toFixed(2));
          } else {
            let sumar = 0;
            descuento = parseFloat(elem.DescuentoReal);
            importe = parseFloat((importe + sumar).toFixed(2));
            precio_unitario = parseFloat((importe / elem.Cantidad).toFixed(2));

            suma_descuento += descuento;
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              let summ = importe - importe / (1 + el.TasaOCuota);
              sumar += parseFloat(summ.toFixed(2));
            });

            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              let summ = importe - importe / (1 + el.TasaOCuota);
              sumar += parseFloat(summ.toFixed(2));
            });
          }

          total_descuento += descuento;
          subtotal += importe;

          if (this.con_impuesto) {
            impuesto_incluido.Traslados = [];
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              if (!suma_impuesto_tras[el.Impuesto]) {
                suma_impuesto_tras[el.Impuesto] = 0;
              }
              suma_impuesto_tras[el.Impuesto] += (importe - descuento) * el.TasaOCuota;
              impuesto_incluido.Traslados.push({
                Traslado: {
                  Base: (importe - descuento).toFixed(2),
                  Impuesto: el.Impuesto,
                  TipoFactor: el.TipoFactor,
                  TasaOCuota: el.TasaOCuota,
                  Importe: ((importe - descuento) * el.TasaOCuota).toFixed(2)
                }
              });
            });

            impuesto_incluido.Retenciones = [];
            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              if (!suma_impuesto_rete[el.Impuesto]) {
                suma_impuesto_rete[el.Impuesto] = 0;
              }
              suma_impuesto_rete[el.Impuesto] += (importe - descuento) * el.TasaOCuota;
              impuesto_incluido.Retenciones.push({
                Retencion: {
                  Base: (importe - descuento).toFixed(2),
                  Impuesto: el.Impuesto,
                  TipoFactor: el.TipoFactor,
                  TasaOCuota: el.TasaOCuota,
                  Importe: ((importe - descuento) * el.TasaOCuota).toFixed(2)
                }
              });
            });
          }
        } else {
          descuento = parseFloat(elem.DescuentoReal);
          importe = parseFloat(elem.ValorUnitario) * elem.Cantidad;
          precio_unitario = parseFloat(elem.ValorUnitario);

          total_descuento += descuento;
          subtotal += importe;
        }
        let ComplementoConcepto = this.facturacion.Conceptos.Concepto[posicion]
          .ComplementoConcepto;
        let iva = this.facturacion.Conceptos.Concepto[posicion].iva;
        this.facturacion.Conceptos.Concepto[posicion] = {
          ClaveProdServ: elem.ClaveProdServ,
          ClaveUnidad: elem.ClaveUnidad,
          NoIdentificacion: elem.NoIdentificacion,
          Cantidad: elem.Cantidad,
          Unidad: elem.Unidad,
          Descripcion: elem.Descripcion,
          ValorUnitario: precio_unitario.toFixed(2),
          PrecioReal: elem.PrecioReal,
          Descuento: descuento.toFixed(2),
          DescuentoReal: elem.DescuentoReal,
          Importe: (parseFloat(elem.Cantidad) * precio_unitario).toFixed(2),
          ComplementoConcepto: ComplementoConcepto,
          iva: iva
        };

        total_subtotal += parseFloat(elem.Cantidad) * precio_unitario;

        if (this.con_impuesto) {
          this.facturacion.Conceptos.Concepto[
            posicion
          ].Impuestos = impuesto_incluido;
        }
        posicion++;
      });

      if (this.con_impuesto) {
        grupos_impuestos.Traslado.forEach(el => {
          if (suma_impuesto_tras[el.Impuesto]) {
            total_total_impuesto_tras += suma_impuesto_tras[el.Impuesto];
            this.facturacion.Impuestos.Traslados.push({
              Traslado: {
                Impuesto: el.Impuesto,
                TipoFactor: el.TipoFactor,
                TasaOCuota: el.TasaOCuota,
                Importe: suma_impuesto_tras[el.Impuesto].toFixed(2)
              }
            });
          }
        });
        grupos_impuestos.Retencion.forEach(el => {
          if (suma_impuesto_rete[el.Impuesto]) {
            total_total_impuesto_rete += suma_impuesto_rete[el.Impuesto];
            this.facturacion.Impuestos.Retenciones.push({
              Retencion: {
                Impuesto: el.Impuesto,
                TipoFactor: el.TipoFactor,
                TasaOCuota: el.TasaOCuota,
                Importe: suma_impuesto_rete[el.Impuesto]
              }
            });
          }
        });

        this.facturacion.Impuestos.TotalImpuestosTrasladados = total_total_impuesto_tras.toFixed(
          2
        );
        this.facturacion.Impuestos.TotalImpuestosRetenidos = total_total_impuesto_rete.toFixed(
          2
        );
      }

      let gran_total =
        total_subtotal -
        total_descuento +
        (total_total_impuesto_tras + total_total_impuesto_rete);

      this.facturacion.SubTotal = total_subtotal.toFixed(2);
      this.facturacion.Descuento = total_descuento.toFixed(2);
      this.facturacion.Total = gran_total.toFixed(2);
    }
  }

  timbrar() {
    document.getElementById("confirmarTimbrar").classList.remove("is-active");
    this.cargando = true;
    let json: any = this.facturacion;
    this.error_timbre = false;
    this.crudService.crear(json, this.CFDI_PATH + "/api/v1/facturar").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status === 201) {
          // datos de respuesta del pac
          let resupuesta = resultado.data;
          // obtener los datos de regreso de la api para la factura
          this.facturacion = resultado.json;

          // guardar la factura local para consultas posteriores
          this.guardar_factura(resultado);

          setTimeout(() => {
            document.getElementById("imprimir_pdf").click();
          }, 250);
        } else {
          if (resultado.messages.errores) {
            this.errores = resultado.messages.errores;
            setTimeout(() => {
              this.errores = [];
            }, 3500 * this.errores.length);
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = "";
            }, 3000);
          }
        }
      },
      error => {
        this.cargando = false;
        this.error_timbre = true;
        setTimeout(() => {
          this.error_timbre = false;
        }, 3500);
      }
    );
  }

  guardar_factura(respuesta) {
    respuesta["ventas"] = this.ventas_facturar;
    this.crudService
      .crear(respuesta, "factura")
      .subscribe(resultado => {
        this.ventas_facturar = [];
      }, error => {});
  }

  quita_poner_iva(item) {
    item.iva = !item.iva;

    if (item.iva) {
      let suma_impuesto_rete = [];
      let suma_impuesto_tras = [];

      let impuesto_incluido = {
        Traslados: [],
        Retenciones: []
      };

      let impuestos = this.configuracion.sucursal.impuestos;
      let desglosar = 0;
      let imp_des = 0;

      impuestos.traslados.forEach(el => {
        let impp =
          item.precio_unitario -
          item.precio_unitario / (1 + parseFloat(el.cuota));
        desglosar += parseFloat(impp.toFixed(2));
        imp_des += parseFloat(el.cuota);
      });

      impuestos.retenciones.forEach(el => {
        let impp =
          item.precio_unitario -
          item.precio_unitario / (1 + parseFloat(el.cuota));
        desglosar += parseFloat(impp.toFixed(2));
        imp_des += parseFloat(el.cuota);
      });

      impuestos.traslados.forEach(el => {
        if (!suma_impuesto_tras[el.clave]) {
          suma_impuesto_tras[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_tras[el.clave] += parseFloat(impp.toFixed(2));
        impuesto_incluido.Traslados.push({
          Traslado: {
            Base: importe_impuesto,
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: impp.toFixed(2)
          }
        });
      });

      impuestos.retenciones.forEach(el => {
        if (!suma_impuesto_rete[el.clave]) {
          suma_impuesto_rete[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_rete[el.clave] += parseFloat(impp.toFixed(2));
        impuesto_incluido.Retenciones.push({
          Retencion: {
            Base: importe_impuesto,
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: impp.toFixed(2)
          }
        });
      });

      item.Impuestos = impuesto_incluido;
    } else {
      delete item.Impuestos;
    }
    this.recalcular_impuesto();
  }

  pagos_publicos = [];
  parametros = {
    pagina: 0,
    limite: 0
  };
  listarBusqueda(term: string): void {
    this.total = 0;
    this.cargando = true;
    this.parametros.pagina = 0;
    this.parametros.limite = 1000;
    this.crudService
      .lista(this.parametros, "pago-publico?columna=&valor=" + term + "&buscar=true&pagina=0&limite=1500")
      .subscribe(
        resultado => {
          this.cargando = false;
          this.pagos_publicos = resultado.data as any[];
        },
        error => {

        }
      );
  }
  seleccione_colegiatura = '';
  asignarPagoPublico(item) {
    const pago = <FormArray>this.dato.controls.pagos;
    this.dato.controls.cuentas_bancarias_id.patchValue(item.cuentas_bancarias_id);
    if (pago.controls[0]["controls"]["importe"].value > 0) {
      this.dato.controls.pagos_publicos_id.patchValue(item.id);
      pago.controls[0]["controls"]["paga_con"].patchValue(item.cantidad);

      document.getElementById("pagosPublicos").classList.remove("is-active");
      this.calcular_importe_articulo();
    } else {
      this.seleccione_colegiatura = "Porfavor... primero agregue un concepto de cobro";
      setTimeout(() => {
        this.seleccione_colegiatura = '';
      }, 3000);
    }
  }
  quitarPagosPublicos() {
    this.dato.controls.pagos_publicos_id.patchValue('');
    const pago = <FormArray>this.dato.controls.pagos;
    if(pago.length)
    pago.controls[0]["controls"]["paga_con"].patchValue("");
    this.calcular_importe_articulo();
  }

  cargarPreinscripcion(preinscripcion){
    this.json = preinscripcion.movimientos;

    this.agregar_forma_pago(<FormArray>(this.dato.controls.pagos), this.form_pagos);

    this.select_articulo_autocomplete(preinscripcion);
    this.reimprimir = true;
  }

  logo;
  logo_sucursal;
  logo_empresa;
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    }
  }
}
